import React, { useState, useEffect } from "react";
import Nav2 from "../../components/navBar/nav2";
import Pcard2 from "../../components/product-card/card2";
import { isAuthenticated } from "../login/auth/auth";
import axios from "axios";
import { API } from "../../Api";
import { Helmet } from "react-helmet";

function createCard(itemData) {
  return (
    <Pcard2
      name={itemData.name}
      coverImage={itemData.coverImage}
      mrp={itemData.mrp}
      sellingPrice={itemData.sellingPrice}
      ratting={itemData.ratting}
      rattingPerson={itemData.rattingPerson}
      stock={itemData.stock}
      unit={itemData.unit}
      packaged={itemData.packaged}
      company={itemData.company}
      veg={itemData.veg}
      id={itemData._id}
    />
  );
}

export default function Vegitables() {
  const [product, setProduct] = useState([]);
  const [loading, setLoading] = useState(true);
  const [amount, setAmount] = useState(20);

  const handleClick = () => {
    setLoading(true);
    setAmount(amount + 15);
  };

  useEffect(() => {
    setLoading(true);
    const { token } = isAuthenticated();
    axios
      .get(
        `${API}products?categorie=vegetable&fields=name,mrp,coverImage,ratting,rattingPerson,stock,sellingPrice,unit,packaged,company,veg,_id&limit=${amount}`,
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then((res) => {
        setLoading(false);
        setProduct(res.data.data.allProduct);
      });
  }, [amount]);
  return (
    <div className="vegitables">
      <Helmet>
        <title>Buy Vegetables🍅 online in Patna | SabjiGrocery.com</title>
        <meta
          name="description"
          content="Buy Vegetables🍅 online at best price💰 in Patna🏙️. Order healthy vegetables at SabjiGrocery. We offer fastest delivery🚚."
        />
      </Helmet>
      <Nav2 />
      {product.map(createCard)}
      <h3 onClick={handleClick}>
        <center>{loading ? "Loading..." : "Show More..."}</center>
      </h3>
    </div>
  );
}
